import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

export function getRouteRoleAccess(route: string): string | undefined {
  const mapping = new Map([['studio', 'apiz-studio-manager']]);
  return mapping.get(route);
}

export const featureAccessGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const keycloak = inject(KeycloakService);
  const role = getRouteRoleAccess(route.routeConfig.path);
  const hasAccess = role ? keycloak.isUserInRole(role) : false;
  return hasAccess;
};
